import { Controller } from "@hotwired/stimulus"

// Кнопки «Поделиться» под открыткой (share-01). Ссылки соцсетей — обычные <a> в
// разметке; здесь только то, что без JS не работает: системное меню и копирование.
//
// «Отправить…» вызывает navigator.share — на телефоне это единственный путь в MAX
// и WhatsApp: веб-интента шаринга у них нет. На десктопе поддержки обычно нет, и
// кнопка не показывается вовсе — остаётся «Скопировать ссылку».
export default class extends Controller {
  static targets = ["native", "copy"]
  static values = {
    url: String,
    title: { type: String, default: "Открытка" },
    copiedLabel: { type: String, default: "Ссылка скопирована" }
  }

  connect() {
    this.copyLabel = this.copyTarget.textContent
    this.copyTarget.hidden = false
    if (navigator.share) this.nativeTarget.hidden = false
  }

  disconnect() {
    clearTimeout(this.restoreTimer)
  }

  async native() {
    try {
      await navigator.share({ title: this.titleValue, url: this.urlValue })
    } catch {
      // Отмена в системном меню — не ошибка, показывать нечего.
    }
  }

  async copy() {
    let copied = false
    try {
      await navigator.clipboard.writeText(this.urlValue)
      copied = true
    } catch {
      copied = this.copyByExecCommand(this.urlValue)
    }

    if (copied) this.flashCopied()
  }

  // Clipboard API живёт только в secure context (https/localhost) и требует
  // разрешения — на остальных случаях остаётся старый способ через textarea.
  copyByExecCommand(text) {
    const area = document.createElement("textarea")
    area.value = text
    area.setAttribute("readonly", "")
    area.style.position = "fixed"
    area.style.top = "-1000px"
    document.body.appendChild(area)
    area.select()

    let copied = false
    try {
      copied = document.execCommand("copy")
    } catch {
      copied = false
    }
    area.remove()

    return copied
  }

  flashCopied() {
    clearTimeout(this.restoreTimer)
    this.copyTarget.textContent = this.copiedLabelValue
    this.copyTarget.classList.add("is-copied")
    this.restoreTimer = setTimeout(() => {
      this.copyTarget.textContent = this.copyLabel
      this.copyTarget.classList.remove("is-copied")
    }, 1800)
  }
}
